import {PageTemplate} from "../../shared/layout/PageTemplate";
import {CompaniesContent} from "./components/CompaniesContent";

export function Companies() {
    return <PageTemplate pageName="Companies" title="Tenders" content={<CompaniesContent/>}/>

}